import * as requestFromServer from "./customerCrud";
import { setErrorTypeAction } from "../errors/errorsActions";
import {setCustomers, setProviders, setSelectedCustomer, setInit} from "./customerSlice";
import { GetAllProducts } from "../products/productsActions";
import {GetCartAction} from "../cart/cartActions";
import routes from "../../app/routes/auth";
import {getProviders} from "./customerCrud";
import { actions as authActions } from "../../app/modules/Auth/_redux/authRedux";
import {copyObject} from "../../shared/utils/objUtils";

const isAdditiveBo = () => process.env.REACT_APP_BO_MODE === "additive";

export const GetCustomerAction = (t) => (dispatch, getState) => {
	return requestFromServer
		.getCustomers()
		.then((response) => {
			const customers = response.customers
			dispatch(setCustomers(customers));
			const idCustomer = localStorage.getItem('customerId');
			if (isAdditiveBo()) {
				// additive (Philips): role come array, un buyer può essere ANCHE backoffice
				const user = copyObject(getState().auth.user);
				if (response.isBackoffice) {
					user.role.push('backoffice');
					dispatch(authActions.setUserRole(user.role));
				}
				const isOnlyBackoffice = user.role.includes('backoffice') && (!user?.role?.find(ele => ele.endsWith(':buyer')) || !idCustomer);
				if (isOnlyBackoffice) {
					routes().firstPage = '/richieste';
				}
				if (!isOnlyBackoffice || idCustomer || customers?.length < 2) {
					const initCustomer = idCustomer && customers.find(ele => ele.id === idCustomer) ? customers.find(ele => ele.id === idCustomer) : customers[0];
					dispatch(setSelectedCustomer(initCustomer));
					dispatch(InitCustomerAction(t));
				}
			} else {
				// exclusive (Linde, default): role stringa singola, BO oppure user
				const role = response.isBackoffice ? 'backoffice' : 'user';
				dispatch(authActions.setUserRole(role));
				if(role === 'backoffice'){
					routes().firstPage = '/richieste'
				}
				if(role !== 'backoffice' || idCustomer){
					const initCustomer = idCustomer && customers.find(ele => ele.id === idCustomer) ? customers.find(ele => ele.id === idCustomer) : customers[0];
					dispatch(setSelectedCustomer(initCustomer))
					dispatch(InitCustomerAction(t));
				}
			}
			dispatch(setInit());
		})
		.catch((error) => {
			dispatch(setErrorTypeAction(t("sg.msg.errorLoadData")));
		});
};
export const InitCustomerAction = (t) => (dispatch, getState) => {
			dispatch(GetCartAction(t));
			dispatch(GetAllProducts(t));
};

export const setProvidersAction = () => (dispatch, getState) => {
	if(!getState().customer.providers.length){
		getProviders().then(res => {
			dispatch(setProviders(res));
		})
	}
};
